import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import { push } from 'connected-react-router'

// amplify
import { Auth, API } from 'aws-amplify'
import { listFundraisingCampaignDiscoveryCallsByFundraisingCampaign, listLocationsByOrganization } from './../../graphql/queries'
import { createAddress, createFundraisingCampaignDiscoveryCall, createLocation, createNylasEvent } from './../../graphql/mutations'

import axios from 'axios'

import { AuthAccount, FundraisingCampaignDiscoveryCall, Location } from '../../../API'
import { Place } from 'aws-sdk/clients/location'
import { AnyRecord } from 'dns'
import { updateNylasPrimaryCalendar } from './authAccount'
import { setLoading } from './loading'

interface CalendarState {
    availableCalendars: any,
    primaryCalendar: any,
    selectedFundraisingCampaignDiscoveryCalls: FundraisingCampaignDiscoveryCall[] | null,
}

const initialState: CalendarState = {
    availableCalendars: null,
    primaryCalendar: null,
    selectedFundraisingCampaignDiscoveryCalls: null
}

export const getAvailableCalendars: any = createAsyncThunk(
    'calendar/getAvailableCalendars',
    async (props: any, { dispatch, getState }) => {
        try {

            const { authAccount }: any = getState()

            if (authAccount && authAccount.selectedStaffProfile && authAccount.selectedStaffProfile.nylasCalendarToken) {
                const response = await axios.get(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/nylas/available-calendars?access_token=${authAccount.selectedStaffProfile.nylasCalendarToken}`)

                console.log(response)

                if (response.data.availableCalendars) {

                    if (authAccount.selectedStaffProfile.nylasPrimaryCalendarID == null && response.data.primaryCalendar) {
                        await dispatch(updateNylasPrimaryCalendar({ calendarID: response.data.primaryCalendar.id }))
                    }

                    return {
                        availableCalendars: response.data.availableCalendars,
                        primaryCalendar: response.data.primaryCalendar ? response.data.primaryCalendar : null
                    }
                }
            } else {
                console.log('Nylas token does not exist')
            }
        } catch (err) {
            console.error(err)
        }
    }
)

export const createBackendFundraisingCampaignDiscoveryCall: any = createAsyncThunk(
    'calendar/createFundraisingCampaignDiscoveryCall',
    async (props: {
        "title": string | null,
        "location": string,
        "description": string | null,
        "startTimestamp": number,
        "endTimestamp": number,
        "conferencingProvider": string,
        "conferencingURL": string,
        "conferencingMeetingCode": string,
        "conferencingPassword": string,
        "conferencingPhone": string[] | null
    }, { dispatch, getState }) => {
        try {

            // Step 1. Create Nylas Event
            // Step 2. Create Backend Object with Nylas Event ID
            // Step 3. Pull in all Campaign Discovery Calls

            dispatch(setLoading({ loading: true, message: 'Adding Discovery Call...' }))

            const { authAccount, fundraising }: any = getState()

            if (authAccount && authAccount.selectedStaffProfile && authAccount.selectedStaffProfile.nylasCalendarToken && authAccount.selectedStaffProfile.nylasPrimaryCalendarID && fundraising.selectedCampaign) {
                const response = await axios.post(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/nylas/discovery-call`, {
                    "calendarID": authAccount.selectedStaffProfile.nylasPrimaryCalendarID,
                    "access_token": authAccount.selectedStaffProfile.nylasCalendarToken,
                    "title": props.title ? props.title : fundraising.selectedCampaign.campaignName ? `${fundraising.selectedCampaign.campaignName} Discovery Call` : 'Latent Discovery Call',
                    "location": props.location,
                    "description": props.description,
                    "startTimestamp": new Date(props.startTimestamp).getTime(),
                    "endTimestamp": new Date(props.endTimestamp).getTime(),
                    "organizerName": authAccount.data ? `${authAccount.data.firstName} ${authAccount.data.lastName}` : 'Unknown',
                    "organizerEmail": authAccount.data && authAccount.data.primaryEmail ? authAccount.data.primaryEmail : '',
                    "conferencingProvider": props.conferencingProvider,
                    "conferencingURL": props.conferencingURL,
                    "conferencingMeetingCode": props.conferencingMeetingCode,
                    "conferencingPassword": props.conferencingPassword,
                    "conferencingPhone": props.conferencingPhone ? props.conferencingPhone : null
                })

                console.log(response)

                const { nylasEvent } = response.data

                console.log(nylasEvent)

                console.log({
                    organizationID: authAccount.selectedStaffProfile.organizationID,
                    fundraisingCampaignID: fundraising.selectedCampaign.id,
                    staffProfileID: authAccount.selectedStaffProfile.id,
                    startTimestamp: props.startTimestamp,
                    endTimestamp: props.endTimestamp,
                    latentHosted: false,
                    nylasEventID: nylasEvent.id
                })

                const { data }: any = await API.graphql({
                    query: createFundraisingCampaignDiscoveryCall,
                    variables: {
                        input: {
                            title: props.title ? props.title : fundraising.selectedCampaign.campaignName ? `${fundraising.selectedCampaign.campaignName} Discovery Call` : 'Latent Discovery Call',
                            organizationID: authAccount.selectedStaffProfile.organizationID,
                            fundraisingCampaignID: fundraising.selectedCampaign.id,
                            staffProfileID: authAccount.selectedStaffProfile.id,
                            startTimestamp: props.startTimestamp,
                            endTimestamp: props.endTimestamp,
                            latentHosted: false,
                            nylasEventID: nylasEvent.id,
                            virtualMeetingURL: props.conferencingURL
                        }
                    }
                })

                const createNylasEventResponse: any = await API.graphql({
                    query: createNylasEvent,
                    variables: {
                        input: {
                            id: nylasEvent.id,
                            calendarID: nylasEvent.calendar_id,
                            owner: nylasEvent.owner,
                            fundraisingCampaignDiscoveryCallID: data.createFundraisingCampaignDiscoveryCall.id,
                            status: nylasEvent.status
                        }
                    }
                })

                console.log(data)

                const listCampaignDiscoveryCallsRespnse: any = await API.graphql({
                    query: listFundraisingCampaignDiscoveryCallsByFundraisingCampaign,
                    variables: {
                        fundraisingCampaignID: fundraising.selectedCampaign.id
                    }
                })

                console.log(listCampaignDiscoveryCallsRespnse)

                dispatch(setLoading({ loading: false, message: 'Adding Discovery Call...' }))

                if (nylasEvent && data.createFundraisingCampaignDiscoveryCall) {
                    return {
                        nylasEvent,
                        discoveryCall: data.createFundraisingCampaignDiscoveryCall,
                        fundraisingCampaignDiscoveryCalls: listCampaignDiscoveryCallsRespnse.data ? listCampaignDiscoveryCallsRespnse.data.listFundraisingCampaignDiscoveryCallsByFundraisingCampaign.items : null
                    }
                }
            } else {
                dispatch(setLoading({ loading: false, message: 'Adding Discovery Call...' }))
                console.log('Error')
            }
        } catch (err) {
            dispatch(setLoading({ loading: false, message: 'Adding Discovery Call...' }))
            console.log(JSON.stringify(err))
            console.log(err)
        }
    }
)

export const getSelectedFundraisingCampaignDiscoveryCalls: any = createAsyncThunk(
    'calendar/getSelectedFundraisingCampaignDiscoveryCalls',
    async (props: any, { dispatch, getState }) => {
        try {

            const { fundraising }: any = getState()

            if (fundraising && fundraising.selectedCampaign) {
                const listCampaignDiscoveryCallsRespnse: any = await API.graphql({
                    query: listFundraisingCampaignDiscoveryCallsByFundraisingCampaign,
                    variables: {
                        fundraisingCampaignID: fundraising.selectedCampaign.id
                    }
                })

                return {
                    fundraisingCampaignDiscoveryCalls: listCampaignDiscoveryCallsRespnse.data ? listCampaignDiscoveryCallsRespnse.data.listFundraisingCampaignDiscoveryCallsByFundraisingCampaign.items : null
                }
            }
        } catch (err) {
            console.error(err)
        }
    }
)

export const calendarSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getAvailableCalendars.fulfilled, (state, { payload }) => {
            if (payload.availableCalendars) state.availableCalendars = payload.availableCalendars
            if (payload.primaryCalendar) state.primaryCalendar = payload.primaryCalendar
        })
        builder.addCase(createBackendFundraisingCampaignDiscoveryCall.fulfilled, (state, { payload }) => {
            if (payload.fundraisingCampaignDiscoveryCalls) state.selectedFundraisingCampaignDiscoveryCalls = payload.fundraisingCampaignDiscoveryCalls
        })
        builder.addCase(getSelectedFundraisingCampaignDiscoveryCalls.fulfilled, (state, { payload }) => {
            if (payload.fundraisingCampaignDiscoveryCalls) state.selectedFundraisingCampaignDiscoveryCalls = payload.fundraisingCampaignDiscoveryCalls
        })
    }
})

export const { } = calendarSlice.actions
export default calendarSlice.reducer